import { Component } from '@angular/core';
import { MainHubService } from './services/main-hub.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  constructor(mainHubService: MainHubService) {
  }
}
